import apiClient from './apiClient';
import { Invitation, InvitationWithDetails, InvitationCreate, InvitationValidationResponse } from '../types';

const apiBaseURL = '/invitations';

/**
 * Service for managing user invitations
 */

/**
 * Create a new invitation
 */
export const createInvitation = async (data: InvitationCreate): Promise<Invitation> => {
  const response = await apiClient.post(`${apiBaseURL}/`, data);
  return response.data;
};

/**
 * Get all invitations for an organization
 */
export const getOrganizationInvitations = async (
  organizationId: string,
  skip: number = 0,
  limit: number = 100
): Promise<InvitationWithDetails[]> => {
  const response = await apiClient.get(`${apiBaseURL}/organization/${organizationId}`, {
    params: { skip, limit }
  });
  return response.data;
};

/**
 * Revoke an invitation
 */
export const revokeInvitation = async (invitationId: string): Promise<Invitation> => {
  const response = await apiClient.delete(`${apiBaseURL}/${invitationId}`);
  return response.data;
};

/**
 * Validate an invitation token (public endpoint)
 */
export const validateInvitationToken = async (token: string): Promise<InvitationValidationResponse> => {
  const response = await apiClient.get(`${apiBaseURL}/validate/${token}`);
  return response.data;
};

/**
 * Accept an invitation (called during signup)
 */
export const acceptInvitation = async (token: string, userEmail: string): Promise<any> => {
  const response = await apiClient.post(`${apiBaseURL}/accept/${token}`, null, {
    params: { user_email: userEmail }
  });
  return response.data;
};

/**
 * Accept an invitation with password (create user account directly)
 */
export const acceptInvitationWithPassword = async (token: string, password: string): Promise<any> => {
  const response = await apiClient.post(`${apiBaseURL}/accept-with-password/${token}`, {
    password
  });
  return response.data;
};

/**
 * Delete all non-pending invitations (accepted, revoked, expired) for an organization
 */
export const cleanupInvitations = async (organizationId: string): Promise<any> => {
  const response = await apiClient.delete(`${apiBaseURL}/organization/${organizationId}/cleanup`);
  return response.data;
};
